import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { RollbarContext, useRollbarPerson } from '@rollbar/react';
import { AnimatePresence } from 'framer-motion';

import AuthWrapper from '@/components/AuthWrapper';

import ProtectedRoute from '@/components/ProtectedRoute';
import AdminRoute from '@/components/AdminRoute';
import Index from '@/pages/Index';
import ActorSelection from '@/pages/ActorSelection';
import ScriptSelection from '@/pages/ScriptSelection';
import Checkout from '@/pages/Checkout';
import OrderConfirmation from '@/pages/OrderConfirmation';
import JwtAuth from '@/pages/JwtAuth';
import ProcessCheckout from '@/pages/ProcessCheckout';
import Dashboard from '@/pages/Dashboard';
import AdminDashboard from '@/pages/AdminDashboard';
import EditVideo from '@/pages/EditVideo';
import Login from '@/pages/Login';
import Error from '@/pages/Error';
import NotFound from '@/pages/NotFound';
import { useAuth } from '@/hooks/useAuth';

const ROUTES = [
  { path: '/', element: <Index /> },
  { path: '/new-video/actor', element: <ActorSelection /> },
  { path: '/new-video/script', element: <ScriptSelection /> },
  { path: '/new-video/checkout', element: <Checkout /> },
  { path: '/order-confirmation', element: <OrderConfirmation /> },
  { path: '/jwt-auth', element: <JwtAuth /> },
  { path: '/process-checkout', element: <ProcessCheckout /> },
  { path: '/dashboard', element: <ProtectedRoute><Dashboard /></ProtectedRoute> },
  { path: '/admin', element: <AdminRoute><AdminDashboard /></AdminRoute> },
  { path: '/edit-video/:id', element: <EditVideo /> },
  { path: '/login', element: <Login /> },
  { path: '/error', element: <Error /> },
  { path: '*', element: <NotFound /> },
];

const UserLogger = () => {
  const { user } = useAuth();
  useRollbarPerson(user);

  return null;
}

const Router = () => {
  const routes = ROUTES.map((route) => {
    const Component = (
      <RollbarContext context={route.path}>
        {route.element}
      </RollbarContext>
    );
    return <Route key={route.path} path={route.path} element={Component} />;
  });

  return (
    <BrowserRouter>
      <UserLogger />
      <AuthWrapper>
        <AnimatePresence mode="wait">
          <Routes>
            { routes }
          </Routes>
        </AnimatePresence>
      </AuthWrapper>
    </BrowserRouter>
  );
};

export default Router;
